export default __webpack_public_path__ + "static/media/image 121.92b6750c.png";